import { P2Accordion, P2Alert, P2TextDescription } from 'react-bootstrap-common-script';
import { useGetSubmittedDocumentsQuery } from '../../../redux/services/getStageE';
import { useAppSelector } from '../../../redux/hook';
import { LottieLoader } from '../../../components/loader';
import { useCallback, useState } from 'react';

interface DocumentsToBringSegmentProps {
  index?: number;
}

const DocumentsToBringSegment: React.FC<DocumentsToBringSegmentProps> = ({ index }) => {
  const queryParameters = new URLSearchParams(window.location.search);
  const application_id = queryParameters.get('application_id');
  const applicationStep4FormData = useAppSelector((state) => state.app.ApplicationStep4Slice.formData);
  const loginUser = useAppSelector((state) => state.auth.AuthenticationSlice.loginUser);
  const singpassToken = useAppSelector((state) => state.auth.AuthenticationSlice.singpassToken);
  const [isAccordionActive, setIsAccordionActive] = useState<boolean>(true);

  console.log('DEBUG - ', applicationStep4FormData);

  const { data, isLoading } = useGetSubmittedDocumentsQuery(
    { application_id: application_id ?? '0', uinfin: loginUser?.uinfin ?? '', singpass_token: singpassToken ?? '' },
    { skip: application_id === '0' || application_id === null }
  );
  

  // Toggle the accordion subtitle when called.
  const handleAccordionSubtitle = useCallback(() => {
    setIsAccordionActive((prev) => !prev);
  }, [data]);

  if (isLoading) {
    return (
      <>
        <LottieLoader />
      </>
    );
  }

  const hasNoData = !data || data?.length === 0
  return (
    <div className='polymer-stage-e-accordion'>
      <P2Accordion
        hasDivider={true}
        defaultOpen={true}
        onToggle={handleAccordionSubtitle}
        title={
          <div className={`polymer-accordion-listing_title ${isAccordionActive ? 'accordion-active' : ''}`}>
            <h4>{index}. Documents to bring</h4>
            {isAccordionActive || !hasNoData && (
              <div className='polymer-stage-e-accordion-subtitle'>
                <P2TextDescription color='#333' description={'Please bring all original documents to your completion appointment.'} />
              </div>
            )}
          </div>
        }>
        {(hasNoData) && (
          <div className='polymer-stage-e-document-items'>
            <P2Alert variant={'info'} withBorder={true} text={'There are no documents required.'} />{' '}
          </div>
        )}

        {data &&
          data.map((e: any, index: number) => {
            return (
              <div key={index} className='polymer-stage-e-document-items'>
                <P2TextDescription color='#333' description={`${index + 1}. ${e?.label}`} />
              </div>
            );
          })}
      </P2Accordion>
    </div>
  );
};

export default DocumentsToBringSegment;
